import { Lens } from '@dhmk/zustand-lens';

import { Cart } from '@/clients/storefront/storefrontClient';

export type ShopifyState = {
  cartId: string | null;
  cart: Cart | null;
  isCartOpen: boolean;
  selectedVariantId: string;
  selectedQuantity: number;
};

export type ShopifyActions = {
  setCartId: (id: string) => void;
  setCart: (cart: Cart) => void;
  setIsCartOpen: (isCartOpen: boolean) => void;
  setSelectedVariantId: (id: string) => void;
};

export type ShopifySlice = ShopifyState & { actions: ShopifyActions };

const sliceName = 'shopify';
export const createShopifySlice: Lens<ShopifySlice> = (set) => ({
  cartId: null,
  cart: null,
  isCartOpen: false,
  selectedVariantId: '',
  selectedQuantity: 1,
  actions: {
    setCartId: (cartId) => set({ cartId }, undefined, `${sliceName}/setCartId`),
    setCart: (cart) => set({ cart }, undefined, `${sliceName}/setCart`),
    setIsCartOpen: (isCartOpen) =>
      set({ isCartOpen }, undefined, `${sliceName}/setIsCartOpen`),
    setSelectedVariantId: (selectedVariantId) =>
      set(
        { selectedVariantId },
        undefined,
        `${sliceName}/setSelectedVariantId`
      ),
  },
});
